.row {
  position: relative;
  display: grid;
  grid-template-columns: 44px 1fr 40px;
  align-items: center;
  gap: 12px;
  background: var(--glass-bg-strong);
  backdrop-filter: var(--glass-blur);
  border-radius: 14px;
  box-shadow: var(--glass-shadow);
  padding: 10px 13px;
}

.row::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(135deg, rgba(var(--accent-light-rgb), 0.16) 0%, rgba(var(--accent-light-rgb), 0.03) 100%);
  -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-color: var(--glass-bg);
  box-shadow: inset 0 0 0 1.5px rgba(var(--accent-rgb), 0.5);
  display: grid;
  place-items: center;
  font-size: 15px;
  font-weight: 600;
  color: var(--accent-hot);
}

.gradientAvatar {
  background-image: radial-gradient(circle at 30% 28%, var(--accent-hot) 0%, var(--accent-deep) 100%);
  color: var(--avatar-initials-color);
}

.who {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.question {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--accent-hot);
}

.name {
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 600;
  font-size: 19px;
  color: var(--text-primary);
  margin: 3px 0 1px;
  letter-spacing: -0.005em;
  line-height: 1.1;
}

.line {
  font-size: 12.5px;
  color: var(--text-secondary);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat {
  appearance: none;
  -webkit-appearance: none;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(var(--accent-rgb), 0.5);
  background: transparent;
  box-shadow: none;
  color: var(--accent);
  display: grid;
  place-items: center;
  cursor: pointer;
}

.chat svg {
  width: 18px;
  height: 18px;
}
